import { DatePickerV2 } from '@profgeosoft-ui/react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { MutableRefObject } from 'react';
import type { DateOnlyPickerField } from 'src/services/directory-service/entities/controls/date-only-picker';
import type { IControl } from 'src/services/directory-service/types';

type Props = {
  control: DateOnlyPickerField;
  className?: string;
  innerRef?: MutableRefObject<HTMLInputElement | null>;
  onChange(control: IControl, value: unknown): void;
  onBlur?(control: IControl): void;
};

export const DateOnlyPickerComponent = wrap<Props>(function DateOnlyPickerComponent({
  innerRef,
  className,
  control,
  onChange,
  onBlur,
}) {
  const { t } = useTranslation();

  const handleChange = (date: number | null) => {
    onChange(control, date);
  };

  const handleBlur = () => {
    onBlur?.(control);
  };

  return (
    <DatePickerV2
      ref={innerRef}
      className={className}
      value={control.value}
      loading={control.isLoading}
      status={control.error ? 'error' : undefined}
      placeholder={t('common:placeholders.chooseDate')}
      disabled={control.isDisabled || control.isEnteringBlocked}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});
